import React, { useState } from "react";
import submit from "submit-form";
import Modal from "../../../../parts/modal-new";
import { RoleSectionComponent } from "./RoleSectionComponent";
import { getRoleNameById, getRolesToShow } from "./utils/manage-coaches-utils";
import getAvatarUrl from "../../../../utils/get-avatar-url";
import Dropdown from "../../../../parts/dropdown";
import SvgIcon from "../../../../parts/SvgIcon";

export const ManageCoachModalComponent = ({ locals }) => {
  const {
    organizationRoles = [],
    query = {},
    usersOrganization,
    organizationOwner,
    activeUser,
  } = locals;
  const { organizationActiveUsers = [] } = usersOrganization;
  const { coachId = null, roleOrganizationName = "" } = query;
  const coach = organizationActiveUsers.find(({ _id }) => _id === coachId);
  const {
    name = "",
    email = "",
    organizationPermissions = [],
    organizationRoleId = null,
    organizationUserStatus = false,
  } = coach;
  const theme = activeUser?.webAppTheme || "dark";
  const image = getAvatarUrl(
    coach,
    null,
    theme,
    theme !== "dark" ? true : false
  );
  //roles to show in dropdwon
  const rolesToShow = getRolesToShow(organizationRoles, roleOrganizationName);

  //state for the checkbox
  const [selectedPermissionsState, setSelectedPermissionsState] = useState(
    organizationPermissions
  );
  //handle the selected role
  const [selectedRoleState, setSelectedRoleState] =
    useState(organizationRoleId);
  //this state is because if the role is admin or owner, all the permissions should be enable
  const [selectedRoleNameState, setSelectedRoleNameState] = useState(
    getRoleNameById(organizationRoles, organizationRoleId)
  );

  const userIsPush = Boolean(organizationOwner.pushAccountInfo);
  const userIsPress = Boolean(organizationOwner.pressAccountInfo);

  //filtering the permissions to show if the user is push or press
  const filteredPermissions = locals.organizationPermissions.filter(
    ({ permission }) => {
      if (
        (permission !== "PUSH" && permission !== "PRESS") ||
        (permission === "PUSH" && userIsPush) ||
        (permission === "PRESS" && userIsPress)
      ) {
        return true;
      }
      return false;
    }
  );

  //to the select all permissions function
  const permissionIds = filteredPermissions.map((permission) => permission._id);

  /**
   * Capture the role selected
   * @param {*} roleId
   */
  const handleSetSelectedRole = (roleId) => {
    setSelectedRoleState(roleId);
    const roleName = getRoleNameById(organizationRoles, roleId);
    setSelectedRoleNameState(roleName);
    if (roleName === "Admin" || roleName === "Owner") {
      selectAll(true);
    }
  };

  /**
   * Handle the selected permissions
   * @param {*} id
   */
  const handleSelectionChange = (id) => {
    if (
      selectedRoleNameState !== "Admin" &&
      selectedRoleNameState !== "Owner"
    ) {
      //code for the check color
      let data = JSON.parse(JSON.stringify(selectedPermissionsState));
      if (!selectedPermissionsState.includes(id)) {
        data.length === 1 && data[0].length === 0
          ? (data = [id])
          : data.push(id);
      } else {
        if (selectedPermissionsState.length > 0) {
          const filetered = data.filter((val) => val != id);
          data = filetered.length > 0 ? filetered : [""];
        }
      }
      setSelectedPermissionsState(data);
    }
  };

  /**
   * Select all the permissions
   */
  const selectAll = (adminSelected = false) => {
    const reset =
      !adminSelected &&
      selectedRoleNameState !== "Admin" &&
      selectedRoleNameState !== "Owner";

    if (
      JSON.stringify(permissionIds) === JSON.stringify(selectedPermissionsState)
    ) {
      if (reset) {
        //unselect all
        setSelectedPermissionsState([""]);
      }
    } else {
      //select all
      setSelectedPermissionsState(permissionIds);
    }
  };

  /**
   * Save user's changes
   * @param {*} e
   */
  const updateUser = (e) => {
    if (selectedPermissionsState[0].length > 0) {
      e.stopPropagation();
      e.preventDefault();

      const body = {
        organizationRoleId: selectedRoleState,
        oldOrganizationPermissions: organizationPermissions, //the permissions before the update
        organizationPermissions: selectedPermissionsState, //the permissions after the update
        userId: coachId,
        organizationUserStatus,
      };

      submit(`/actions/organizations/update-user`, {
        method: "POST",
        body,
      });
    }
  };

  return (
    <Modal
      className={"manage-coach"}
      changeCloseIcon={true}
      overflowModal={true}
      title="Manage Coach"
    >
      <div className="body">
        <article>
          <div className="left">
            <div
              className="avatar"
              style={{
                background: `url(${image})`,
                backgroundPosition: "center center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
              }}
            ></div>
            <div className="coach-info">
              <p className="s1">{name}</p>
              <p className="p4 opacity-70">{email}</p>
            </div>
          </div>
          <div className="right">
            <Dropdown
              summaryText={selectedRoleNameState}
              options={rolesToShow.map((role) => {
                return { text: role.role, value: role._id };
              })}
              onSelectFn={handleSetSelectedRole}
            />
          </div>
        </article>
        <label>Permissions:</label>
        <section role="table-wrapper" data-borders-inside>
          <table role="report-table">
            <thead>
              <th>
                <SvgIcon
                  onClick={() => {
                    selectAll();
                  }}
                  src={`/img/new-icons/${
                    JSON.stringify(permissionIds) ===
                    JSON.stringify(selectedPermissionsState)
                      ? "checked-square.svg"
                      : "unchecked-square.svg"
                  }`}
                  noFilterOnLight
                />
              </th>
              <th>
                <p className="s1">Permissions</p>
              </th>
            </thead>
            <tbody>
              {filteredPermissions.map((item, idx) => {
                const { _id, permission } = item;
                const permissionFormat =
                  permission === "PUSH"
                    ? "PUSH (Subscriptions)"
                    : permission === "PRESS"
                    ? "PRESS (Gym Management)"
                    : permission;
                return (
                  <tr key={_id}>
                    <td>
                      {selectedPermissionsState.includes(_id) ? (
                        <SvgIcon
                          src="/img/new-icons/checked-square.svg"
                          alt="checked"
                          style={{
                            cursor:
                              selectedRoleNameState === "Admin" ||
                              selectedRoleNameState === "Owner"
                                ? "not-allowed"
                                : "pointer",
                          }}
                          onClick={() => handleSelectionChange(_id)}
                          noFilterOnLight
                        />
                      ) : (
                        <SvgIcon
                          src="/img/new-icons/unchecked-square.svg"
                          alt="unchecked"
                          onClick={() => handleSelectionChange(_id)}
                        />
                      )}
                    </td>
                    <td>
                      <span className="permission-name-manage">
                        {permissionFormat}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </section>
      </div>
      <footer>
        <button
          data-button-type="secondary"
          data-action="cancel"
          onClick={() =>
            submit("/actions/refresh", {
              method: "GET",
              body: {
                modal: "",
              },
            })
          }
        >
          Cancel
        </button>
        <button
          data-button-type="primary"
          disabled={selectedPermissionsState[0].length > 0 ? undefined : true}
          onClick={updateUser}
        >
          Save
        </button>
      </footer>
    </Modal>
  );
};
